<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleRequisicao"
             color="primary"
             class="rounded-tag-small normal-btn-text elevation-0"
             link to="/cadastro-requisicao">
        <v-icon left>mdi-plus</v-icon>
        Solicitação
      </v-btn>
      <v-btn v-if="hasRoleComprador"
             class="rounded-tag-small normal-btn-text elevation-0 ml-3"
             link to="/requisicoes/gerar">
        <v-icon>mdi-format-list-bulleted</v-icon>
        Agrupar Solicitações
      </v-btn>
      <v-spacer/>
      <v-btn v-if="hasFilters"
             small
             text
             class="normal-btn-text rounded-tag-small mt-1"
             @click="clearFilters">
        Limpar filtros
        <v-icon right small color="error">mdi-close</v-icon>
      </v-btn>
      <v-btn icon @click="onClickRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-listagem-requisicao-filtros ref="filtros" @change="emitChange"/>
      <px-search-text class="rounded-tag-small"
                      label="Busque por solicitante, empresa ou identificador"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListagemRequisicaoFiltros from './ListagemRequisicaoFiltros.vue';

export default {
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'RASCUNHO',
          description: 'Rascunhos',
          value: ['RASCUNHO'],
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['RECEBIDA'],
        },
        {
          id: 'EM_ANDAMENTO',
          description: 'Em andamento',
          value: ['EM_COMPRA', 'EM_COTACAO'],
        },
        {
          id: 'CANCELADAS',
          description: 'Canceladas',
          value: ['CANCELADA'],
        },
        {
          id: 'FINALIZADAS',
          description: 'Finalizadas',
          value: ['FINALIZADA'],
        },
      ],
    };
  },
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemRequisicao', ['hasCustomFilters']),
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleRequisicao']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemRequisicao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemRequisicao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemRequisicao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemRequisicao/searchText', searchText);
      },
    },
    hasFilters() {
      return this.hasCustomFilters || this.searchText;
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    clearFilters() {
      this.searchText = null;
      this.$refs.filtros.clearFilters();
    },
  },
  created() {
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
  components: {
    pxListagemRequisicaoFiltros: ListagemRequisicaoFiltros,
  },
};
</script>
